import View from '@shared/components/layout-default/layout-default-router-view';

export const phone_lists = {
  path: 'phone-lists',
  component: View,
  children: [
    {
      path: '',
      name: 'pbx.phone-list.index',
      component: () =>
        import(
          /* webpackChunkName: 'pbx-phone-lists' */
          '@pbx/pages/phone-lists/list'
        ),
      meta: {
        title: { code: 'pbx.breadcrumb.phone-list.index' }
      }
    },

    {
      path: 'new',
      name: 'pbx.phone-list.create',
      component: () =>
        import(
          /* webpackChunkName: 'pbx-phone-lists' */
          '@pbx/pages/phone-lists/form'
        ),
      meta: {
        title: { code: 'pbx.breadcrumb.phone-list.create' }
      }
    },

    {
      path: ':id([\\d]*)',
      name: 'pbx.phone-list.edit',
      component: () =>
        import(
          /* webpackChunkName: 'pbx-phone-lists' */
          '@pbx/pages/phone-lists/form'
        ),
      meta: {
        title: {
          code: 'pbx.breadcrumb.phone-list.edit'
        },
        loadable: true
      }
    }
  ]
};
